( function( ) {
	var columns = $('.matchH').matchHeight();
}) ( );
